import { EmailOnlyOtp, EmailOtp, SmsOtp, SmsPhoneOtp } from "@pcln/account-less-auth-sdk";
import { otpDeliveryMechanisms } from "../constants/index.js";
const getSdk = ({ deliveryType, url })=>{
    switch(deliveryType){
        case otpDeliveryMechanisms.SMS:
            return new SmsOtp(url);
        case otpDeliveryMechanisms.SMS_PHONE:
            return new SmsPhoneOtp(url);
        case otpDeliveryMechanisms.EMAIL:
            return new EmailOtp(url);
        case otpDeliveryMechanisms.EMAIL_ONLY_OTP:
            return new EmailOnlyOtp(url);
    }
};
const otpService = ({ deliveryType })=>{
    const url = 'account-less-auth';
    const accountLessSdk = getSdk({
        deliveryType,
        url
    });
    if (!accountLessSdk) throw new Error('AccountLess Sdk needs to be initialized');
    let verifyFn = null;
    return {
        createChallenge: async ({ scope, requestFrom, countryCode, phoneNumber, email, requestHeaders })=>{
            try {
                verifyFn = null;
                const accountLessSdkPromise = accountLessSdk.withScope(scope).withRequestFrom(requestFrom);
                if (deliveryType !== otpDeliveryMechanisms.SMS_PHONE) accountLessSdkPromise.withEmail(email);
                if (deliveryType !== otpDeliveryMechanisms.EMAIL_ONLY_OTP) accountLessSdkPromise.withPhoneNumber(countryCode, phoneNumber);
                const challenge = await accountLessSdkPromise.build().createChallenge({
                    headers: requestHeaders
                });
                if (challenge.success) {
                    verifyFn = challenge.verify;
                    return challenge.success;
                }
                throw new Error('Unable to create a challenge');
            } catch (_e) {
                throw new Error('Account less sdk api error');
            }
        },
        verify: async (otpCode)=>{
            if (verifyFn) try {
                const verifyResult = await verifyFn(otpCode);
                return {
                    success: verifyResult.success,
                    token: verifyResult.success ? verifyResult.token : ''
                };
            } catch (_e) {
                throw new Error('Otp verificaton api failed');
            }
            throw new Error('Verification function is required');
        }
    };
};
const utils_otpService = otpService;
export { utils_otpService as default };
